module.exports = __webpack_public_path__ + "img/EGTB.93bc7bf0.png";